import { __read } from "tslib";
import React, { useEffect, useState } from 'react';
import { ProductGridViewToggle } from './components/ProductGridViewToggle';
import { subscribeStickyTitle } from './stickyTitleStore';
/** Header title that subscribes to sticky stack — isolated from ProductList body re-renders. */
export var ProductListStickyTitle = function (_a) {
    var gridViewMode = _a.gridViewMode, onGridViewChange = _a.onGridViewChange;
    var _b = __read(useState(undefined), 2), title = _b[0], setTitle = _b[1];
    useEffect(function () { return subscribeStickyTitle(setTitle); }, []);
    return (React.createElement("div", { className: "product-list__header" },
        React.createElement("span", { className: "product-list__header__text" }, title),
        React.createElement("div", { className: "product-list__header__view desktop-only" },
            React.createElement(ProductGridViewToggle, { value: gridViewMode, onChange: onGridViewChange }))));
};
export default ProductListStickyTitle;
//# sourceMappingURL=ProductListStickyTitle.js.map